import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { layout: 'LoginLayout' }
  },
  {
    path: '/',
    name: '',
    component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue')
  },
  {
    path: '/leadsdashboard',
    name: 'LeadsDashboard',
    component: () => import(/* webpackChunkName: "about" */ '../views/LeadsDashboard.vue')
  },
  {
    path: '/demandfunnel',
    name: 'DemandFunnel',
    component: () => import(/* webpackChunkName: "about" */ '../views/DemandFunnel.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "about" */ '../views/Settings.vue')
  },
  {
    path: '/salarycosts',
    name: 'SalaryCosts',
    component: () => import('../views/SalaryCosts.vue')
  },
  {
    path: '/performance-report',
    name: 'PerformanceReport',
    component: () => import('../views/PerformanceReport.vue')
  },
  {
    path: '/syndicate-dashboard',
    name: 'SyndicateDashboard',
    component: () => import('../views/SyndicateDashboard.vue')
  },
    {
    path: '/mandate-dashboard',
    name: 'MandateDashboard',
    component: () => import('../views/MandateDashboard.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
